@import '~less/bootstrap/legacy-mixins';
@import '~less/global-variables';
@import '~less/layout/typography';

/*
 * Buttons
 */
.btn {
  .font-brand-regular();
  text-shadow: none;
  &,
  &:hover {
    box-shadow: none;
  }

  &.btn-default {
    &:hover {
      border-color: @btn-default-border;
    }
  }

  // New button styles
  &.btn-inverse {
    .button-variant(@btn-inverse-color; @btn-inverse-bg; @btn-inverse-border);
    &:hover {
      border-color: rgba(
        red(@btn-inverse-border),
        green(@btn-inverse-border),
        blue(@btn-inverse-border),
        0.8
      );
      background-color: rgba(
        red(@btn-inverse-border),
        green(@btn-inverse-border),
        blue(@btn-inverse-border),
        0.1
      );
    }
  }
  &.btn-inverse-primary {
    .button-variant(@btn-inverse-primary-color; @btn-inverse-primary-bg; @btn-inverse-primary-border);
    &:hover {
      border-color: rgba(
        red(@btn-inverse-primary-border),
        green(@btn-inverse-primary-border),
        blue(@btn-inverse-primary-border),
        0.8
      );
      background-color: rgba(
        red(@btn-inverse-primary-border),
        green(@btn-inverse-primary-border),
        blue(@btn-inverse-primary-border),
        0.1
      );
    }
  }

  // Special colors for buttons appended to inputs
  &.btn-input {
    .button-variant(@brand-primary; @input-bg; @input-border);
  }

  // Bigger button size `action`
  &.btn-action {
    padding: 15px 30px;
    font-size: 20px;
  }
}
// Fix problem with inverse button hover state covering input border
.input-group-btn:last-child > .btn.btn-inverse {
  margin-left: 0;
}

/*
 * Button mixings
 */
.btn-icon() {
  color: @gray-light;
  text-decoration: none;
  &:hover {
    color: @gray-light;
    text-decoration: none;
  }
}

/**
 * App store badges
 */
.btn-app {
  display: block;
  max-width: 150px;
  padding: 0;
  line-height: 1rem;
  border-radius: 4px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1);
}

/**
 * Circle button
 * Width and height should be the same for this
 */
.btn-round {
  border-radius: 50%;
  // Force horizontally and vertical paddings equal for all button sizes
  padding: @padding-base-vertical;
  &.btn-action {
    padding: 15px;
  }
  &.btn-lg {
    padding: @padding-large-vertical;
  }
  &.btn-sm {
    padding: @padding-small-vertical;
  }
  &.btn-xs {
    padding: @padding-xs-vertical;
  }
}

// When `btn-round` is part of input group
.input-group-btn:first-child > .btn-round,
.input-group-btn:last-child > .btn-round {
  border-radius: 50%;
}

/**
 * Button with slight shadow under it
 */
.btn-raised {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

/*
 * Hosting buttons
 */
.btn-offer-hosting-yes {
  .button-variant(#fff; @offer-hosting-yes; @offer-hosting-yes);
}
.btn-offer-hosting-maybe {
  .button-variant(#fff; @offer-hosting-maybe; @offer-hosting-maybe);
}
.btn-offer-hosting-no {
  .button-variant(#fff; @offer-hosting-no; @offer-hosting-no);
}
.btn-offer-meet {
  .button-variant(#fff; @offer-meet; @offer-meet);
}
.btn-offer-hosting {
  .hosting-status {
    color: #fff;
  }
  .caret {
    border-top-color: #fff;
  }
}
